import { render } from "./NoRecordsCard.vue?vue&type=template&id=52316e39&scoped=true"
import script from "./NoRecordsCard.vue?vue&type=script&lang=js"
export * from "./NoRecordsCard.vue?vue&type=script&lang=js"

import "./NoRecordsCard.vue?vue&type=style&index=0&id=52316e39&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52316e39"]])

export default __exports__